module.exports = __webpack_public_path__ + "static/media/writtendesk.9414b994.png";